import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { DateService } from '../services/date-service';
import { Moment } from 'moment';
import TimeUtils from '../utils/time-utils';

@Pipe({
  name: 'formatDate',
  standalone: false,
})
export class FormatDate implements PipeTransform {
  constructor(
    private translateService: TranslateService,
    private readonly dateService: DateService,
  ) {}
  transform(value, type?: string) {
    let date = null;
    if (value) {
      if (typeof value === 'string' || value instanceof Date) {
        date = TimeUtils.getMomentFormatted(value, 'YYYY-MM-DDThh:mm:ss');
      } else {
        date = this.dateService.unixToDate(value);
      }
      const todaysDate = TimeUtils.getMoment();
      let yesterdaysDate = TimeUtils.getMoment(todaysDate);
      yesterdaysDate = TimeUtils.getMoment(yesterdaysDate.date(yesterdaysDate.date() - 1));
      if (type === 'unixToDate') {
        return date;
      }
      if (
        todaysDate.date() === date.date() &&
        todaysDate.month() === date.month() &&
        todaysDate.year() === date.year()
      ) {
        let today;
        this.translateService.get('time.today').subscribe((text) => {
          today = text;
        });
        return (type === 'live' ? '' : today) + ' ' + this.getTime(date, type);
      } else if (
        yesterdaysDate.date() === date.date() &&
        yesterdaysDate.month() === date.month() &&
        yesterdaysDate.year() === date.year()
      ) {
        let yesterday;
        this.translateService.get('time.yesterday').subscribe((text) => {
          yesterday = text;
        });
        return yesterday + ' ' + this.getTime(date);
      } else {
        if (type === 'standartDateFromMoment') return TimeUtils.getUnixFormattedDate(value);
        if (type === 'standartDateFromDate') return TimeUtils.getFormattedDate(value);
        const currentYear = new Date().getFullYear();
        const dayOfWeek = this.shortWeekdayTranslate(date.day());
        const month = this.shortMonthTranslate(date.month());
        const dayOfMonth = date.date();
        // 'withYear' always spells the year out, so a date in the current year cannot be read as another year's.
        if (type === 'withYear') {
          return dayOfWeek + ' ' + dayOfMonth + ' ' + month + ' ' + date.year() + ' ' + this.getTime(date);
        }
        let dateResultString =
          currentYear !== date.year()
            ? dayOfWeek + ' ' + dayOfMonth + ' ' + month + ' ' + date.year()
            : dayOfWeek + ' ' + dayOfMonth + ' ' + month + ' ' + this.getTime(date);
        return dateResultString;
      }
    }
  }

  private getTime(date: Moment, type?: string) {
    let hours = date.hours().toString();
    let minutes = date.minutes().toString();
    let seconds = date.seconds().toString();
    if (date.hours() < 10) {
      hours = '0' + hours;
    }
    if (date.minutes() < 10) {
      minutes = '0' + minutes;
    }
    if (date.seconds() < 10) {
      seconds = '0' + seconds;
    }
    return hours + ':' + minutes + (type === 'live' ? ':' + seconds : '');
  }

  private shortWeekdayTranslate(day: number) {
    let dayName;
    this.translateService.get('time.days').subscribe((days) => {
      dayName = days[day];
    });
    return dayName;
  }

  private shortMonthTranslate(month: number) {
    let monthName;
    this.translateService.get('time.months').subscribe((months) => {
      monthName = months[month];
    });
    return monthName;
  }
}
